function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import Upscope from "./sdk.js";
var UpscopeContext = createContext({
    Upscope: undefined,
    shortId: undefined,
    getLookupCode: function getLookupCode() {
        return _asyncToGenerator(function() {
            return __generator(this, function(_state) {
                return [
                    2,
                    ""
                ];
            });
        })();
    },
    listen: function(event, callback) {},
    reset: function() {},
    isSharing: false
});
export function useUpscope() {
    return useContext(UpscopeContext);
}
export function UpscopeProvider(_param) {
    var getLookupCode = function getLookupCode() {
        return new Promise(function(resolve) {
            if (!loaded || !enabled) {
                return resolve(undefined);
            }
            Upscope("getLookupCode", function(lookupCode) {
                resolve(lookupCode);
            });
        });
    };
    var listen = function listen(event, callback) {
        Upscope("on", event, callback);
    };
    var reset = function reset() {
        Upscope("reset", true);
    };
    var children = _param.children, enabled = _param.enabled, config = _objectWithoutProperties(_param, [
        "children",
        "enabled"
    ]);
    var _useState = _slicedToArray(useState(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), sharing = _useState1[0], setSharing = _useState1[1];
    var _useState2 = _slicedToArray(useState(undefined), 2), shortId = _useState2[0], setShortId = _useState2[1];
    enabled !== null && enabled !== void 0 ? enabled : enabled = true;
    useEffect(function() {
        if (enabled && !loaded) {
            setLoaded(true);
            Upscope("init", config);
        } else if (!enabled && loaded) {
            Upscope("reset", false);
            setShortId(undefined);
        }
    }, [
        enabled,
        loaded,
        config
    ]);
    useEffect(function() {
        if (enabled && loaded) {
            Upscope("updateConnection", config);
            Upscope("getShortId", function(shortId) {
                setShortId(shortId);
            });
        }
    }, [
        enabled,
        loaded,
        config
    ]);
    useEffect(function() {
        if (loaded) {
            Upscope("on", "sessionStart", function() {
                setSharing(true);
            });
            Upscope("on", "sessionContinue", function() {
                setSharing(true);
            });
            Upscope("on", "sessionEnd", function() {
                setSharing(false);
            });
        }
    }, [
        loaded
    ]);
    return _jsx(UpscopeContext.Provider, {
        value: {
            Upscope: Upscope,
            shortId: shortId,
            getLookupCode: getLookupCode,
            listen: listen,
            reset: reset,
            isSharing: sharing
        },
        children: children
    });
}
export function Masked(param) {
    var children = param.children;
    var beforeRef = useRef(null);
    var afterRef = useRef(null);
    useEffect(function() {
        if (beforeRef.current && afterRef.current) {
            var nextSibling = beforeRef.current.nextSibling;
            while(nextSibling && nextSibling !== afterRef.current){
                nextSibling.dataset.upscopeMasked = true;
                nextSibling = nextSibling.nextSibling;
            }
        }
    }, [
        beforeRef,
        afterRef,
        children
    ]);
    return _jsxs(_Fragment, {
        children: [
            _jsx("script", {
                ref: beforeRef
            }),
            children,
            _jsx("script", {
                ref: afterRef
            })
        ]
    });
}
export function NoRemoteControl(param) {
    var children = param.children;
    var beforeRef = useRef(null);
    var afterRef = useRef(null);
    useEffect(function() {
        if (beforeRef.current && afterRef.current) {
            var nextSibling = beforeRef.current.nextSibling;
            while(nextSibling && nextSibling !== afterRef.current){
                nextSibling.dataset.upscopeNoRemoteControl = true;
                nextSibling = nextSibling.nextSibling;
            }
        }
    }, [
        beforeRef,
        afterRef,
        children
    ]);
    return _jsxs(_Fragment, {
        children: [
            _jsx("script", {
                ref: beforeRef
            }),
            children,
            _jsx("script", {
                ref: afterRef
            })
        ]
    });
}


//# sourceMappingURL=index.js.map